import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { sendTwilioEvent } from '@actions';
import useIsRestricted from '@hooks/useIsRestricted';
import * as actions from '@actions';

const useSendTwilioEvents = () => {
  const isRestricted = useIsRestricted();
  const dispatch = useDispatch();

  return useCallback(
    (params: Omit<Parameters<typeof actions.sendTwilioEvent>[0], 'isRestricted'>) =>
      dispatch(sendTwilioEvent({ ...params, isRestricted })),
    [dispatch, isRestricted]
  );
};

export default useSendTwilioEvents;
